import {LOAD_CATEGORIES, CHANGE_CATEGORY} from '../../actions/actionTypes';

export function storeCategoriesReducer(state, action) {
    //FIXME replace [] with {}
    state = state || [];
    switch (action.type) {
        case LOAD_CATEGORIES:
            return Object.assign([], state, action.categories);
        case CHANGE_CATEGORY: {
            let newState = Object.assign([], state);
            newState.forEach((c, idx, array) => {
                let newC;
                if (c.key === action.key) {
                    newC = Object.assign({}, c);
                    newC.selected = true;
                } else {
                    if (c.selected) {
                        newC = Object.assign({}, c);
                        newC.selected = false;
                    }
                }
                if (newC) {
                    array[idx] = newC;
                }

            });
            return newState;
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/store/storeCategoriesReducer.js